<section>
  <div class="release-interpretation">{{'Are you sure you want to release for interpretation?' | stringTranslate}}</div>
  <ng-container *ngFor="let provider of providers">
    <input type="checkbox" class="provider-checkbox" [(ngModel)]="provider.enabled"/>
    <span>Request {{provider.name}} interpretation</span>
  </ng-container>
</section>

